import React from 'react'
import { TableHeadersType } from '../../constant/tableHeadersConstants/tableHeadersType';

type AppProps={
    tableHeaders: TableHeadersType[] | [];
    data: any [] | [];
}

const TimeSheetUnfilledDatesReportTable = ({data ,tableHeaders }:AppProps) => {
  return (
    <>

{data?.length > 0 &&
        data?.map((unFilledData: any) => {
          return (
            <tr className="text-left">
              {tableHeaders?.length > 0 &&
                tableHeaders?.map((header: TableHeadersType) => {
                  if (header?.value == "date") {
                    return (
                      <td className="text-left">
                        {unFilledData?.date}
                      </td>
                    );
                  } else if (header?.value == "day") {
                    return (
                      <td className="text-left">
                        {unFilledData?.day}
                      </td>
                    );
                  } 
                  return null;
                })}
            </tr>
          );
        })}
      
    </>
  )
}

export default TimeSheetUnfilledDatesReportTable
